import { takeLatest, all, takeEvery } from "redux-saga/effects";
import * as usersManager from "../modules/UserManager/redux/sagas/handleUserManager";
import * as constants from "../modules/UserManager/redux/constants";
import * as departConstants from "../modules/DepartmentEmails/redux/constants";
import * as departEmails from "../modules/DepartmentEmails/redux/sagas/handleDepartEmails";
import * as departmentsConstants from "../modules/ActivityTypes/redux/constants";
import * as departments from "../modules/ActivityTypes/redux/sagas/handleActivityTypes";
import * as prodStatuses from "../modules/ProjectStatuses/redux/sagas/handleActivityTypes";
import * as prodStatusesConstants from "../modules/ProjectStatuses/redux/constants";
import * as handleSales from "../modules/Sales/redux/sagas/handleSales";
import * as handleSalesConstants from "../modules/Sales/redux/constants";
import * as ims from "../modules/IMS/redux/sagas/imsSagas";
import * as imsConstants from "../modules/IMS/redux/constants";
import * as documentControlSagas from "../modules/DocumentControl/redux/sagas/documentControlSagas";
import * as documentConstants from "../modules/DocumentControl/redux/constants";
import * as authSagas from "../modules/login/redux/sagas/handleAuth";
import * as authConstants from "../modules/login/redux/constants";
import * as productionSagas from "../modules/Production/redux/sagas/handleProduction";
import * as productionConstants from "../modules/Production/redux/constants";
import * as projectSetupSagas from "../modules/ProjectSetup/redux/sagas/handleProjectsSetupManager";
import * as projectSetupConstants from "../modules/ProjectSetup/redux/constants";
import * as revisionStatuses from "../modules/RevisionStatuses/redux/sagas/handleRevision";
import * as revisionConstants from "../modules/RevisionStatuses/redux/revisionConstants";
import * as docStatusesSagas from "../modules/DocumentStatuses/redux/sagas/handleDocStatuses";
import * as docStatusesConstants from "../modules/DocumentStatuses/redux/constants";
import * as documentfields from "../modules/DefaultDocumentFields/redux/sagas/handleActivityTypes";
import * as documentfieldConstants from "../modules/DefaultDocumentFields/redux/constants";
import * as docTypesSagas from "../modules/DocumentsTypesManager/redux/sagas/handleTemplates";
import * as docTypesConstants from "../modules/DocumentsTypesManager/redux/constants";
import * as imsDocRevisionsSagas from "../modules/IMS/tableSection/revisions/redux/sagas/imsRevisionsSagas";
import * as imsDocRevisionsConstants from "../modules/IMS/tableSection/revisions/redux/constants";
import * as imsDocDistributionSagas from "../modules/IMS/tableSection/distributionTable/redux/sagas/imsDistributionSagas";
import * as imsDocDistributionConstants from "../modules/IMS/tableSection/distributionTable/redux/constants";
import * as projects from "../modules/Projects/redux/sagas/projectSagas";
import * as projectsConstants from "../modules/Projects/redux/constants";
import * as projectDocRevisionsSagas from "../modules/Projects/tableSection/revisions/redux/sagas/projectRevisionsSagas";
import * as projectDocRevisionsConstants from "../modules/Projects/tableSection/revisions/redux/constants";
import * as projectDocDistributionSagas from "../modules/Projects/tableSection/distributionTable/redux/sagas/projectDistributionSagas";
import * as projectDocDistributionConstants from "../modules/Projects/tableSection/distributionTable/redux/constants";
import * as notificationsSagas from "../modules/container/notifications/notificationsRedux/saga";
import * as notificationsConstants from "../modules/container/notifications/notificationsRedux/constant";

function* watcherSaga() {
  yield takeEvery(
    documentConstants.CREATE_DOCUMENT_CONTROL,
    documentControlSagas.handleCreateDocument
  );
  yield takeEvery(
    documentConstants.DELETE_DOCUMENT_CONTROL,
    documentControlSagas.handleDeleteDocumentAttach
  );
  yield takeEvery(
    documentConstants.FETCH_DOCUMENT_CONTROL,
    documentControlSagas.handleFetchDocument
  );
  yield takeEvery(
    documentConstants.FETCH_DOCUMENT_CONTROL_SEARCH_DATA,
    documentControlSagas.handleFetchDocumentUtilsData
  );
  yield takeEvery(
    documentConstants.UPDATE_DOCUMENT_CONTROL,
    documentControlSagas.handleUpdateDocument
  );
  yield takeEvery(
    documentConstants.ADD_DOCUMENT_CONTROL_ATTACH,
    documentControlSagas.handleAddDocumentAttach
  );
  yield takeEvery(
    documentConstants.DELETE_DOCUMENT_CONTROL_ATTACH,
    documentControlSagas.handleDeleteDocumentAttach
  );

  yield takeLatest(
    docTypesConstants.FETCH_ALL_TEMPLATES,
    docTypesSagas.handleFetchAllTemplates
  );
  yield takeLatest(
    docTypesConstants.FETCH_TEMPLATE,
    docTypesSagas.handleFetchTemplate
  );
  yield takeLatest(
    docTypesConstants.CREATE_TEMPLATE,
    docTypesSagas.handleCreateTemplate
  );
  yield takeLatest(
    docTypesConstants.UPDATE_TEMPLATE,
    docTypesSagas.handleUpdateTemplates
  );
  yield takeLatest(
    docTypesConstants.DELETE_TEMPLATE,
    docTypesSagas.handleDeleteTemplate
  );
  yield takeLatest(
    prodStatusesConstants.FETCH_PROJECT_STATUSES,
    prodStatuses.handleFetchProjectStatuses
  );
  yield takeLatest(
    prodStatusesConstants.UPDATE_PROJECT_STATUSES,
    prodStatuses.handleUpdateProjectStatuses
  );
  yield takeLatest(
    prodStatusesConstants.DELETE_PROJECT_STATUSES,
    prodStatuses.handleDeleteProjectStatuses
  );
  yield takeLatest(
    prodStatusesConstants.CREATE_PROJECT_STATUSES,
    prodStatuses.handleCreateProjectStatuses
  );

  yield takeLatest(
    prodStatusesConstants.UPDATE_ORDER,
    prodStatuses.handleUpdateProjectOrder
  );

  yield takeLatest(
    docStatusesConstants.FETCH_DOC_STATUSES,
    docStatusesSagas.handleFetchDocStatuses
  );
  yield takeLatest(
    docStatusesConstants.UPDATE_DOC_STATUSES,
    docStatusesSagas.handleUpdateDocStatuses
  );

  yield takeLatest(
    docStatusesConstants.UPDATE_DOC_COMPLETED_STATUS,
    docStatusesSagas.handleUpdateDocCompletedStatuses
  );

  yield takeLatest(
    docStatusesConstants.DELETE_DOC_STATUSES,
    docStatusesSagas.handleDeleteDocStatuses
  );
  yield takeLatest(
    docStatusesConstants.CREATE_DOC_STATUSES,
    docStatusesSagas.handleCreateDocStatuses
  );

  yield takeLatest(
    docStatusesConstants.UPDATE_DOC_STATUS_ORDER,
    docStatusesSagas.handleUpdateDocOrder
  );

  yield takeLatest(constants.CREATE_USER, usersManager.handleCreateUser);
  yield takeLatest(constants.FETCH_ALL_USERS, usersManager.handleFetchAllUsers);
  yield takeLatest(
    constants.FETCH_USERS_UTIL_DATA,
    usersManager.handleFetchUserDetailsUtils
  );
  yield takeEvery(constants.DELETE_USER, usersManager.handleDeleteUser);

  yield takeLatest(constants.SAVE_DEPARTMENT, usersManager.handleAddDepartment);
  yield takeLatest(constants.FETCH_USER, usersManager.handleFetchUser);
  yield takeEvery(constants.UPDATE_USER, usersManager.handleUpdateUser);
  yield takeEvery(
    constants.UPDATE_USER_SETTINGS,
    usersManager.handleUpdateUserSettings
  );
  yield takeLatest(
    constants.SEND_DETAILS_TO_USER,
    usersManager.handleSendDetailsToUser
  );

  yield takeLatest(
    constants.CREATE_USER_PROJECT,
    usersManager.handleCreateProject
  );
  yield takeLatest(
    constants.UPDATE_USER_PROJECT,
    usersManager.handleUpdateUserProject
  );
  yield takeLatest(
    constants.DELETE_USER_PROJECT,
    usersManager.handleDeleteUserProject
  );
  yield takeLatest(
    revisionConstants.FETCH_REVISION_STATUSES,
    revisionStatuses.handleFetchRevisionStatuses
  );
  yield takeLatest(
    revisionConstants.CREATE_REVISION_STATUSES,
    revisionStatuses.handleCreateRevisionStatuses
  );
  yield takeLatest(
    revisionConstants.UPDATE_REVISION_STATUSES,
    revisionStatuses.handleUpdateRevisionStatuses
  );
  yield takeLatest(
    revisionConstants.UPDATE_ORDER_REVISION_STATUS,
    revisionStatuses.handleUpdateRevisionOrder
  );
  yield takeLatest(
    revisionConstants.DELETE_REVISION_STATUSES,
    revisionStatuses.handleDeleteRevisionStatuses
  );
  yield takeLatest(
    departConstants.FETCH_DEPART_EMAILS,
    departEmails.handleFetchDepartEmails
  );
  yield takeLatest(
    departConstants.UPDATE_DEPART_EMAIL,
    departEmails.handleUpdateDepartEmail
  );
  yield takeLatest(
    departmentsConstants.FETCH_DEPARTMENTS,
    departments.handleFetchDepartments
  );
  yield takeEvery(
    departmentsConstants.UPDATE_DEPARTMENTS,
    departments.handleUpdateDepartment
  );
  yield takeEvery(
    departmentsConstants.DELETE_DEPARTMENTS,
    departments.handleDeleteDepartments
  );
  yield takeEvery(
    departmentsConstants.CREATE_DEPARTMENTS,
    departments.handleCreateDepartment
  );
  yield takeLatest(
    constants.UPDATE_USER_PERMISSIONS,
    usersManager.handleUpdateUserPermissions
  );
  yield takeLatest(
    handleSalesConstants.FETCH_SALES,
    handleSales.handleFetchSalesData
  );
  yield takeLatest(
    handleSalesConstants.FETCH_SALES_SEARCH_UTILS,
    handleSales.handleFetchSalesUtilsData
  );
  yield takeLatest(
    handleSalesConstants.FETCH_SALES_SECOND_LEVEL,
    handleSales.handleFetchSalesSecondLevelData
  );
  yield takeLatest(
    handleSalesConstants.FETCH_SALES_GRAPH,
    handleSales.handleFetchSalesGraphData
  );

  yield takeEvery(imsConstants.FETCH_IMS_DOCS, ims.handleFetchImsDocs);
  yield takeEvery(imsConstants.FETCH_BATCH_UPDATE, ims.handleBatchUpdate);
  yield takeEvery(imsConstants.CREATE_IMS_DOC, ims.handleCreateImsDoc);
  yield takeEvery(imsConstants.DELETE_IMS_DOC, ims.handleDeleteImsDoc);
  yield takeEvery(imsConstants.FETCH_ACTIVITIES, ims.handleFetchActivities);
  yield takeEvery(
    imsConstants.FETCH_ACTIVITIES_SEARCH_DATA,
    ims.handleFetchActivitiesUtilsData
  );
  yield takeEvery(imsConstants.UPDATE_ACTIVITY, ims.handleUpdateActivity);
  yield takeEvery(imsConstants.ADD_IMS_DOC_ATTACH, ims.handleAddActivityAttach);
  yield takeEvery(
    imsConstants.DELETE_IMS_DOC_ATTACH,
    ims.handleDeleteImsDocAttach
  );

  yield takeLatest(
    productionConstants.FETCH_PROD_SEARCH_UTILS,
    productionSagas.handleFetchProdSearchUtils
  );

  yield takeLatest(
    productionConstants.FETCH_PROD_FIRST_LEVEL,
    productionSagas.handleFetchProdFirstLevel
  );
  yield takeLatest(
    productionConstants.FETCH_PROD_GRAPH_DATA,
    productionSagas.handleFetchProdGraphData
  );
  yield takeLatest(
    productionConstants.FIRST_LEVEL_ADD_COMMENT,
    productionSagas.handleAddFirstLevelComment
  );
  yield takeEvery(
    productionConstants.ADD_PRODUCTION_ATTACH,
    productionSagas.handleAddProdAttach
  );
  yield takeEvery(
    productionConstants.DELETE_PROD_ATTACH,
    productionSagas.handleDeleteProdAttach
  );
  yield takeLatest(
    productionConstants.FETCH_PROD_SECOND_LEVEL,
    productionSagas.handleFetchProdSecondLevel
  );

  yield takeEvery(
    productionConstants.CREATE_SECOND_LEVEL,
    productionSagas.handleCreateProdSecondLevel
  );

  yield takeEvery(
    productionConstants.UPDATE_SECOND_LEVEL,
    productionSagas.handleUpdateProdSecondLevel
  );

  yield takeLatest(
    productionConstants.FETCH_PROD_THIRD_LEVEL,
    productionSagas.handleFetchProdThirdLevel
  );

  yield takeLatest(
    productionConstants.FETCH_PROD_FOURTH_LEVEL,
    productionSagas.handleFetchProdFourthLevel
  );

  yield takeEvery(
    productionConstants.VERIFY_PIN,
    productionSagas.handleVerifyPin
  );

  yield takeEvery(
    productionConstants.UPDATE_OPERATOR,
    productionSagas.handleUpdateOperator
  );

  yield takeEvery(
    productionConstants.STOP_OPERATOR,
    productionSagas.handleStopOperator
  );

  yield takeEvery(
    productionConstants.ADD_OPERATOR,
    productionSagas.handleAddOperator
  );

  yield takeEvery(authConstants.LOGIN, authSagas.handleLoginUser);
  yield takeEvery(authConstants.LOGOUT, authSagas.handleLogoutUser);
  yield takeEvery(
    authConstants.FETCH_SIDEBAR_PROJECTS,
    authSagas.handleFetchSidebarProjects
  );

  yield takeLatest(
    projectSetupConstants.FETCH_ALL_PROJECTS,
    projectSetupSagas.handleFetchAllProjects
  );

  yield takeLatest(
    projectSetupConstants.FETCH_PROJECT,
    projectSetupSagas.handleFetchProject
  );
  yield takeLatest(
    projectSetupConstants.CREATE_PROJECT,
    projectSetupSagas.handleCreateProject
  );
  yield takeLatest(
    projectSetupConstants.UPDATE_PROJECT,
    projectSetupSagas.handleUpdateProject
  );
  yield takeLatest(
    projectSetupConstants.DELETE_PROJECT,
    projectSetupSagas.handleDeleteProject
  );
  yield takeLatest(
    projectSetupConstants.DELETE_PROJECT_ATTACH,
    projectSetupSagas.handleDeleteProjectAttach
  );
  yield takeLatest(
    projectSetupConstants.UPDATE_PROJECT_NOTIFICATION,
    projectSetupSagas.handleUpdateProjectNotifications
  );
  yield takeLatest(
    constants.FETCH_ALL_USER_PROJECTS,
    usersManager.handleFetchAllUserProjects
  );
  yield takeLatest(
    documentfieldConstants.FETCH_DOCUMENT_FIELDS,
    documentfields.handleFetchDocumentField
  );
  yield takeLatest(
    documentfieldConstants.UPDATE_DOCUMENT_FIELDS,
    documentfields.handleUpdateDocumentField
  );
  yield takeEvery(
    imsDocRevisionsConstants.FETCH_IMS_REVISIONS,
    imsDocRevisionsSagas.handleFetchImsRevisions
  );
  yield takeEvery(
    imsDocRevisionsConstants.CREATE_IMS_REVISIONS,
    imsDocRevisionsSagas.handleCreateImsRevision
  );
  yield takeEvery(
    imsDocRevisionsConstants.UPDATE_IMS_REVISIONS,
    imsDocRevisionsSagas.handleUpdateImsRevision
  );
  yield takeEvery(
    imsDocRevisionsConstants.DELETE_IMS_REVISIONS,
    imsDocRevisionsSagas.handleDeleteImsRevision
  );
  yield takeEvery(
    imsDocRevisionsConstants.DELETE_IMS_REVISIONS_ATTACH,
    imsDocRevisionsSagas.handleDeleteImsRevisionAttach
  );
  yield takeEvery(
    imsDocRevisionsConstants.ADD_IMS_REVISIONS_ATTACH,
    imsDocRevisionsSagas.handleAddImsRevisionAttach
  );

  yield takeLatest(
    imsDocDistributionConstants.FETCH_IMS_DISTRIBUTION,
    imsDocDistributionSagas.handleFetchImsDistribution
  );
  yield takeEvery(
    imsDocDistributionConstants.CREATE_IMS_DISTRIBUTION,
    imsDocDistributionSagas.handleCreateImsDistribution
  );
  yield takeEvery(
    imsDocDistributionConstants.UPDATE_IMS_DISTRIBUTION,
    imsDocDistributionSagas.handleUpdateImsDistribution
  );
  yield takeEvery(
    imsDocDistributionConstants.DELETE_IMS_DISTRIBUTION,
    imsDocDistributionSagas.handleDeleteImsDistribution
  );
  yield takeEvery(
    imsDocDistributionConstants.DELETE_IMS_DISTRIBUTION_ATTACH,
    imsDocDistributionSagas.handleDeleteImsDistributionAttach
  );
  yield takeEvery(
    imsDocDistributionConstants.ADD_IMS_DISTRIBUTION_ATTACH,
    imsDocDistributionSagas.handleAddImsDistributionAttach
  );

  yield takeLatest(
    projectsConstants.FETCH_PROJECT_DOCS,
    projects.handleFetchProjectDocs
  );
  yield takeEvery(
    projectsConstants.FETCH_PROJECT_BATCH_UPDATE,
    projects.handleBatchUpdate
  );
  yield takeEvery(
    projectsConstants.CREATE_PROJECT_DOC,
    projects.handleCreateProjectDoc
  );
  yield takeEvery(
    projectsConstants.DELETE_PROJECT_DOC,
    projects.handleDeleteProjectDoc
  );
  yield takeEvery(
    projectsConstants.FETCH_PROJECT_ACTIVITIES,
    projects.handleFetchActivities
  );
  yield takeEvery(
    projectsConstants.FETCH_PROJECT_ACTIVITIES_SEARCH_DATA,
    projects.handleFetchActivitiesUtilsData
  );
  yield takeEvery(
    projectsConstants.UPDATE_PROJECT_ACTIVITY,
    projects.handleUpdateActivity
  );
  yield takeEvery(
    projectsConstants.ADD_PROJECT_DOC_ATTACH,
    projects.handleAddActivityAttach
  );
  yield takeEvery(
    projectsConstants.DELETE_PROJECT_DOC_ATTACH,
    projects.handleDeleteProjectDocAttach
  );

  yield takeEvery(
    projectDocRevisionsConstants.FETCH_PROJECT_REVISIONS,
    projectDocRevisionsSagas.handleFetchProjectRevisions
  );
  yield takeEvery(
    projectDocRevisionsConstants.CREATE_PROJECT_REVISIONS,
    projectDocRevisionsSagas.handleCreateProjectRevision
  );
  yield takeEvery(
    projectDocRevisionsConstants.UPDATE_PROJECT_REVISIONS,
    projectDocRevisionsSagas.handleUpdateProjectRevision
  );
  yield takeEvery(
    projectDocRevisionsConstants.DELETE_PROJECT_REVISIONS,
    projectDocRevisionsSagas.handleDeleteProjectRevision
  );
  yield takeEvery(
    projectDocRevisionsConstants.DELETE_PROJECT_REVISIONS_ATTACH,
    projectDocRevisionsSagas.handleDeleteProjectRevisionAttach
  );
  yield takeEvery(
    projectDocRevisionsConstants.ADD_PROJECT_REVISIONS_ATTACH,
    projectDocRevisionsSagas.handleAddProjectRevisionAttach
  );

  yield takeEvery(
    projectDocDistributionConstants.FETCH_PROJECT_DISTRIBUTION,
    projectDocDistributionSagas.handleFetchProjectDistribution
  );
  yield takeEvery(
    projectDocDistributionConstants.CREATE_PROJECT_DISTRIBUTION,
    projectDocDistributionSagas.handleCreateProjectDistribution
  );
  yield takeEvery(
    projectDocDistributionConstants.UPDATE_PROJECT_DISTRIBUTION,
    projectDocDistributionSagas.handleUpdateProjectDistribution
  );
  yield takeEvery(
    projectDocDistributionConstants.DELETE_PROJECT_DISTRIBUTION,
    projectDocDistributionSagas.handleDeleteProjectDistribution
  );
  yield takeEvery(
    projectDocDistributionConstants.DELETE_PROJECT_DISTRIBUTION_ATTACH,
    projectDocDistributionSagas.handleDeleteProjectDistributionAttach
  );
  yield takeEvery(
    projectDocDistributionConstants.ADD_PROJECT_DISTRIBUTION_ATTACH,
    projectDocDistributionSagas.handleAddProjectDistributionAttach
  );
  yield takeLatest(
    notificationsConstants.FETCH_NOTIFICATIONS_LIST,
    notificationsSagas.handleFetchAllNotifications
  );
  yield takeLatest(
    notificationsConstants.FETCH_NOTIFICATIONS,
    notificationsSagas.handleFetchUnreadNotificationCount
  );
  yield takeLatest(
    notificationsConstants.UPDATE_NOTIFICATION,
    notificationsSagas.handleUpdateNotification
  );
}

export function* rootSaga() {
  yield all([watcherSaga()]);
}
